import {StabilityRuleFormSchema} from '@/modules/drug-catalog/stability-rules/schemas'
import {SortSchema} from '@cypro/ui/schemas'
import {CatalogType} from '@cypro/engine/database/schema'
import {
  ActiveSubstanceTradeNameSchemaFields,
  BaseTradeNameSchema,
  SolutionTradeNameSchemaFields,
  SupportiveMedicationTradeNameTradeNameSchemaFields,
} from '@cypro/engine/mutators'
import {tradeNameRefinement} from '@cypro/engine/mutators'
import * as z from 'zod'

export const NewTradeNamePageSearchSchema = z.object({
  tradeNameId: z.uuidv7().optional(),
  type: CatalogType.optional(),
})

export const TradeNamesSearchSchema = z.object({
  filters: z
    .object({
      search: z.string().optional(),
      substances: z.array(z.uuidv7()).optional(),
      forms: z.array(z.uuidv7()).optional(),
      types: z.array(CatalogType).optional(),
    })
    .optional(),
  sort: z.array(SortSchema).default([{id: 'name', desc: false}]),
})

const BaseTNameSchema = BaseTradeNameSchema.omit({stabilityRules: true}).extend({
  stabilityRules: z.array(StabilityRuleFormSchema),
  drugCatalogItemId: z.uuidv7().nonempty(),
})

export const TradeNameFormSchema = z
  .discriminatedUnion('type', [
    BaseTNameSchema.extend(ActiveSubstanceTradeNameSchemaFields),
    BaseTNameSchema.extend(SupportiveMedicationTradeNameTradeNameSchemaFields),
    BaseTNameSchema.extend(SolutionTradeNameSchemaFields),
  ])
  .superRefine(tradeNameRefinement)
export type TradeNameFormSchema = z.infer<typeof TradeNameFormSchema>
